/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfAddressDto } from "../models/AjaxResponseOfAddressDto";
import type { AjaxResponseOfBoolean } from "../models/AjaxResponseOfBoolean";
import type { AjaxResponseOfFileDto } from "../models/AjaxResponseOfFileDto";
import type { AjaxResponseOfGetVendorForEditOutput } from "../models/AjaxResponseOfGetVendorForEditOutput";
import type { AjaxResponseOfGetVendorForViewDto } from "../models/AjaxResponseOfGetVendorForViewDto";
import type { AjaxResponseOfGetVendorForViewPublicDto } from "../models/AjaxResponseOfGetVendorForViewPublicDto";
import type { AjaxResponseOfListOfComboboxItemDto } from "../models/AjaxResponseOfListOfComboboxItemDto";
import type { AjaxResponseOfPagedResultDtoOfGetVendorForViewDto } from "../models/AjaxResponseOfPagedResultDtoOfGetVendorForViewDto";
import type { AjaxResponseOfVendorDto } from "../models/AjaxResponseOfVendorDto";
import type { CreateOrEditVendorDto } from "../models/CreateOrEditVendorDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class VendorsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfListOfComboboxItemDto
   * @throws ApiError
   */
  public getAllUserAssignedVendors({
    userId,
  }: {
    userId: number;
  }): CancelablePromise<AjaxResponseOfListOfComboboxItemDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vendors/{userId}",
      path: {
        userId: userId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfComboboxItemDto
   * @throws ApiError
   */
  public getAllVendorsAssignedToCurrentUser(): CancelablePromise<AjaxResponseOfListOfComboboxItemDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vendors/get-all-vendors-assigned-to-current-user",
    });
  }

  /**
   * @returns AjaxResponseOfGetVendorForViewDto
   * @throws ApiError
   */
  public getVendorForView({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfGetVendorForViewDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vendors/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public createOrEdit({
    requestBody,
  }: {
    requestBody?: CreateOrEditVendorDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vendors",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id?: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/vendors",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfPagedResultDtoOfGetVendorForViewDto
   * @throws ApiError
   */
  public getAll({
    filter,
    maxCreationTimeFilter,
    minCreationTimeFilter,
    maxLastModificationTimeFilter,
    minLastModificationTimeFilter,
    maxDeletionTimeFilter,
    minDeletionTimeFilter,
    isDeletedFilter,
    cnpjFilter,
    businessNameFilter,
    tradeNameFilter,
    zipCodeFilter,
    addressFilter,
    maxNumberFilter,
    minNumberFilter,
    complementFilter,
    cityFilter,
    stateFilter,
    districtFilter,
    businessPhoneNumberFilter,
    businessPhoneNumber2Filter,
    mobilePhoneNumberFilter,
    emailAddressFilter,
    isActiveFilter,
    ibgeCityCodeFilter,
    typeFilter,
    makeNameFilter,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    maxCreationTimeFilter?: string;
    minCreationTimeFilter?: string;
    maxLastModificationTimeFilter?: string;
    minLastModificationTimeFilter?: string;
    maxDeletionTimeFilter?: string;
    minDeletionTimeFilter?: string;
    isDeletedFilter?: number;
    cnpjFilter?: string;
    businessNameFilter?: string;
    tradeNameFilter?: string;
    zipCodeFilter?: string;
    addressFilter?: string;
    maxNumberFilter?: number;
    minNumberFilter?: number;
    complementFilter?: string;
    cityFilter?: string;
    stateFilter?: string;
    districtFilter?: string;
    businessPhoneNumberFilter?: string;
    businessPhoneNumber2Filter?: string;
    mobilePhoneNumberFilter?: string;
    emailAddressFilter?: string;
    isActiveFilter?: number;
    ibgeCityCodeFilter?: string;
    typeFilter?: number;
    makeNameFilter?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfGetVendorForViewDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vendors",
      query: {
        filter: filter,
        maxCreationTimeFilter: maxCreationTimeFilter,
        minCreationTimeFilter: minCreationTimeFilter,
        maxLastModificationTimeFilter: maxLastModificationTimeFilter,
        minLastModificationTimeFilter: minLastModificationTimeFilter,
        maxDeletionTimeFilter: maxDeletionTimeFilter,
        minDeletionTimeFilter: minDeletionTimeFilter,
        isDeletedFilter: isDeletedFilter,
        cnpjFilter: cnpjFilter,
        businessNameFilter: businessNameFilter,
        tradeNameFilter: tradeNameFilter,
        zipCodeFilter: zipCodeFilter,
        addressFilter: addressFilter,
        maxNumberFilter: maxNumberFilter,
        minNumberFilter: minNumberFilter,
        complementFilter: complementFilter,
        cityFilter: cityFilter,
        stateFilter: stateFilter,
        districtFilter: districtFilter,
        businessPhoneNumberFilter: businessPhoneNumberFilter,
        businessPhoneNumber2Filter: businessPhoneNumber2Filter,
        mobilePhoneNumberFilter: mobilePhoneNumberFilter,
        emailAddressFilter: emailAddressFilter,
        isActiveFilter: isActiveFilter,
        ibgeCityCodeFilter: ibgeCityCodeFilter,
        typeFilter: typeFilter,
        makeNameFilter: makeNameFilter,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }

  /**
   * @returns AjaxResponseOfVendorDto
   * @throws ApiError
   */
  public getVendorByVehicleAdId({
    id,
  }: {
    id?: string;
  }): CancelablePromise<AjaxResponseOfVendorDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vendors/get-vendor-by-vehicle-ad-id",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGetVendorForEditOutput
   * @throws ApiError
   */
  public getVendorForEdit({
    id,
  }: {
    id?: number;
  }): CancelablePromise<AjaxResponseOfGetVendorForEditOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vendors/get-vendor-for-edit",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGetVendorForViewPublicDto
   * @throws ApiError
   */
  public getVendorForViewPublic({
    id,
  }: {
    id?: number;
  }): CancelablePromise<AjaxResponseOfGetVendorForViewPublicDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vendors/get-vendor-for-view-public",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfFileDto
   * @throws ApiError
   */
  public getVendorsToExcel({
    filter,
    maxCreationTimeFilter,
    minCreationTimeFilter,
    maxLastModificationTimeFilter,
    minLastModificationTimeFilter,
    maxDeletionTimeFilter,
    minDeletionTimeFilter,
    isDeletedFilter,
    cnpjFilter,
    businessNameFilter,
    tradeNameFilter,
    zipCodeFilter,
    addressFilter,
    maxNumberFilter,
    minNumberFilter,
    complementFilter,
    cityFilter,
    stateFilter,
    districtFilter,
    businessPhoneNumberFilter,
    businessPhoneNumber2Filter,
    mobilePhoneNumberFilter,
    emailAddressFilter,
    isActiveFilter,
    ibgeCityCodeFilter,
    typeFilter,
    makeNameFilter,
  }: {
    filter?: string;
    maxCreationTimeFilter?: string;
    minCreationTimeFilter?: string;
    maxLastModificationTimeFilter?: string;
    minLastModificationTimeFilter?: string;
    maxDeletionTimeFilter?: string;
    minDeletionTimeFilter?: string;
    isDeletedFilter?: number;
    cnpjFilter?: string;
    businessNameFilter?: string;
    tradeNameFilter?: string;
    zipCodeFilter?: string;
    addressFilter?: string;
    maxNumberFilter?: number;
    minNumberFilter?: number;
    complementFilter?: string;
    cityFilter?: string;
    stateFilter?: string;
    districtFilter?: string;
    businessPhoneNumberFilter?: string;
    businessPhoneNumber2Filter?: string;
    mobilePhoneNumberFilter?: string;
    emailAddressFilter?: string;
    isActiveFilter?: number;
    ibgeCityCodeFilter?: string;
    typeFilter?: number;
    makeNameFilter?: string;
  }): CancelablePromise<AjaxResponseOfFileDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vendors/get-vendors-to-excel",
      query: {
        filter: filter,
        maxCreationTimeFilter: maxCreationTimeFilter,
        minCreationTimeFilter: minCreationTimeFilter,
        maxLastModificationTimeFilter: maxLastModificationTimeFilter,
        minLastModificationTimeFilter: minLastModificationTimeFilter,
        maxDeletionTimeFilter: maxDeletionTimeFilter,
        minDeletionTimeFilter: minDeletionTimeFilter,
        isDeletedFilter: isDeletedFilter,
        cnpjFilter: cnpjFilter,
        businessNameFilter: businessNameFilter,
        tradeNameFilter: tradeNameFilter,
        zipCodeFilter: zipCodeFilter,
        addressFilter: addressFilter,
        maxNumberFilter: maxNumberFilter,
        minNumberFilter: minNumberFilter,
        complementFilter: complementFilter,
        cityFilter: cityFilter,
        stateFilter: stateFilter,
        districtFilter: districtFilter,
        businessPhoneNumberFilter: businessPhoneNumberFilter,
        businessPhoneNumber2Filter: businessPhoneNumber2Filter,
        mobilePhoneNumberFilter: mobilePhoneNumberFilter,
        emailAddressFilter: emailAddressFilter,
        isActiveFilter: isActiveFilter,
        ibgeCityCodeFilter: ibgeCityCodeFilter,
        typeFilter: typeFilter,
        makeNameFilter: makeNameFilter,
      },
    });
  }

  /**
   * @returns AjaxResponseOfBoolean
   * @throws ApiError
   */
  public isLandingPageEnabledForVendor({
    id,
  }: {
    id?: number;
  }): CancelablePromise<AjaxResponseOfBoolean> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vendors/is-landing-page-enabled-for-vendor",
      query: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfAddressDto
   * @throws ApiError
   */
  public getVendorMainAddress({
    vendorId,
  }: {
    vendorId?: number;
  }): CancelablePromise<AjaxResponseOfAddressDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vendors/get-vendor-main-address",
      query: {
        vendorId: vendorId,
      },
    });
  }
}
